import { css } from "@emotion/react";

export const divider = ({ theme }) => css`
  background-color: ${theme.colors.secondary.lines};
`;
